import axios from "axios";
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";
const API_KEY = process.env.REACT_APP_API_SECRET_KEY;
export const getIsApprovedByAdmin = async (email) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/is-approved?email=${email}`,
      {
        headers: {
          "X-API-Key": API_KEY,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
  }
};
